<template>
    <div class="OrderAdmin spackage bgc padding-20 box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="助力订单" name="first">
                <AssOrderPage></AssOrderPage>
            </el-tab-pane>
            <el-tab-pane label="购买订单" name="second">
                <BuyOrderPage></BuyOrderPage>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import AssOrderPage from 'views/taskTools/helpManagement/components/AssOrderPage'
import BuyOrderPage from 'views/taskTools/helpManagement/components/BuyOrderPage'
export default {
    name: 'OrderAdmin',
    data() {
        return {
            activeName: 'first'
        }
    },
    mounted() {},
    methods: {
        handleClick(tab, event) {}
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        AssOrderPage,
        BuyOrderPage
    }
}
</script>

<style lang="scss" type="text/scss">
.OrderAdmin {
    padding-top: 0;
    .el-tabs__header {
        margin: 0;
    }
    .flex_box{
        display: flex;
    }
    .search_box {
        margin-bottom: 30px;
        flex-wrap: wrap;
        &>div {
            margin-top: 20px;
            margin-right: 30px;
            .el-input__icon {
                line-height: 2px;
            }
            .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                width: 350px;
            }
            .el-date-editor .el-range-separator {
                line-height: 26px;
            }
        }
        &>div:nth-last-of-type(1){
            .el-button+.el-button {
                margin-left: 30px;
            }
            margin-right: 0px;
        }
    }
    .table_box {
        .el-table__empty-block {
            min-height: 500px;
        }
        // .el-table th>.cell {
        //     font-weight: bold!important;
        //     // white-space: nowrap;
        //     font-size: 16px;
        // }
        .green_text {
            color: #67C23A;
        }
        .yellow_text {
            color: #E6A23C;
        }
        .gray_text {
            color: #909399;
        }
        .user_info_box {
            align-items: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .activity_name_text {
            text-align: justify;
        }
        .handle_box {
            align-items: center;
            justify-content: flex-end;
            span {
                color: #439FFE;
                cursor: pointer;
            }
        }
    }
    .order_detail_pop_box, .help_detail_pop_box {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            width: 672px;
            // height: 600px;
            margin: 0!important;
        }
        .el-dialog .el-dialog__body {
            padding: 28px!important;
            height: 100%;
        }
    }
    .help_detail_pop_box {
        .el-dialog {
            width: 678px;
            // height: 1084px;
        }
        .el-dialog .el-dialog__body {
            padding: 20px!important;
        }
    }
}
</style>